import { SignedIn, SignedOut, SignInButton, UserButton, RedirectToSignIn } from '@clerk/clerk-react'

export function AuthCard() {
  return (
    <div className="flex items-center justify-center min-h-[50vh]">
      <div className="card p-8 text-center max-w-sm w-full">
        <h1 className="text-2xl font-bold mb-2">高考学习平台</h1>
        <p className="text-ink-500 dark:text-ink-300 mb-6">登录以开始今天的学习</p>
        <SignedOut>
          <SignInButton mode="modal">
            <button className="btn-primary w-full">登录 / 注册</button>
          </SignInButton>
        </SignedOut>
        <SignedIn>
          <div className="flex items-center gap-3">
            <UserButton afterSignOutUrl="/" />
            <span className="text-sm">已登录</span>
          </div>
        </SignedIn>
      </div>
    </div>
  )
}

export function AuthGuard({ children }) {
  return (
    <>
      <SignedIn>{children}</SignedIn>
      <SignedOut>
        <RedirectToSignIn />
      </SignedOut>
    </>
  )
}
